import request from '@/utils/request'

// 查询区域列表分页
export function fetchList(query) {
    return request({
        url: '/system/tenant/sms/page',
        method: 'get',
        params: query,
    })
}
// 查询区域详细
export function getObj(id) {
    return request({
        url: '/system/tenant/sms/detail?id=' + id,
        method: 'get',
    })
}
// 新增区域
export function addObj(data) {
    return request({
        url: '/system/tenant/sms/add',
        method: 'post',
        data: data,
    })
}

// 修改区域
export function putObj(data) {
    return request({
        url: '/system/region/edit',
        method: 'post',
        data: data,
    })
}
// 删除区域
export function delObj(data) {
    return request({
        url: '/system/tenant/sms/delete',
        method: 'post',
        data: data,
    })
}